module.exports = __webpack_public_path__ + "img/Spread_2.864250c3.jpg";